import { GET_AGREEMENTS } from './../constants';
import { handleActions } from "redux-actions"

export const agreements  = handleActions(
  {
    [ GET_AGREEMENTS ]: (state, action) =>  action.payload
  }, []
)